import { CalendarEntry } from "Components/Calendar/CalendarEntryHelper";
import moment, { Moment } from "moment";
import { CellSize } from "Components/Calendar/CalendarHelper";
import { ResizePixelSet } from "Components/Resize/ResizeHelper";
import { DropArea } from "Components/DropArea/types/DropArea";

export function getWeekCalendarEntries(
	calendarEntries: CalendarEntry[],
	startOfWeek: Moment
) {
	const endOfWeek = startOfWeek.clone().add(1, "week");

	return calendarEntries.filter((scheduleEntry) => {
		const startTime = moment.unix(scheduleEntry.startTime);
		const endTime = moment.unix(scheduleEntry.endTime);

		return startTime.isBefore(endOfWeek) && endTime.isAfter(startOfWeek);
	});
}

export function isWeekCalendarEntryStartingInsideColumn(
	startOfWeek: moment.Moment,
	weekday: number,
	calendarEntry: CalendarEntry
) {
	const endOfWeek = startOfWeek.clone().add(1, "week");
	const startOfDay = startOfWeek.clone().add(weekday, "days");
	const endOfDay = startOfDay.clone().add(1, "day");
	const startTime = moment.unix(calendarEntry.startTime);
	const endTime = moment.unix(calendarEntry.endTime);

	if (endTime.isBefore(startOfWeek) || startTime.isAfter(endOfWeek)) {
		return false;
	} else if (
		startTime.isSameOrAfter(startOfDay) &&
		startTime.isBefore(endOfDay)
	) {
		return true;
	} else if (weekday === 0) {
		return startTime.isBefore(startOfDay);
	} else {
		return false;
	}
}

export function isWeekDropAreaStartingInsideColumn(
	startOfWeek: moment.Moment,
	weekday: number,
	dropArea: DropArea
) {
	const startOfDay = startOfWeek.clone().add(weekday, "days");
	const endOfDay = startOfDay.clone().add(1, "day");

	return (
		dropArea.start.isSameOrAfter(startOfDay) &&
		dropArea.start.isBefore(endOfDay)
	);
}

export function getIsWeekSingleRow(calendarEntries: CalendarEntry[]) {
	const sortedEntries = [...calendarEntries].sort(
		(a, b) => a.startTime - b.startTime
	);

	for (let i = 0; i < sortedEntries.length - 1; i++) {
		if (sortedEntries[i].endTime > sortedEntries[i + 1].startTime) {
			return false;
		}
	}

	return true;
}

export function getWeekSchedulePhasesResizePixelSet(
	startOfWeek: Moment,
	cellSize: CellSize
) {
	const offsetPixel = cellSize.week.nameWidth + cellSize.offset.left;
	const resizePixelSet: ResizePixelSet = {
		left: [],
		right: [],
	};

	for (let weekday = 0; weekday <= 6; weekday++) {
		const dateTime = startOfWeek.clone().add(weekday, "days");

		resizePixelSet.left.push({
			pixel: offsetPixel + cellSize.week.dayWidth * weekday,
			dateTime: dateTime.clone(),
		});

		resizePixelSet.right.push({
			pixel: offsetPixel + cellSize.week.dayWidth * (weekday + 1) - 1,
			dateTime: dateTime.clone(),
		});
	}

	return resizePixelSet;
}
